import type { Optional } from '@direct-frontend/stdlib';
import type { SchemaMediaItemMetadata } from '../../../api/openApi';

export function getUniformBackground(meta?: SchemaMediaItemMetadata): Optional<string> {
    const { top, left, bottom, right } = meta?.background_colors ?? {};

    if (top && top === left && top === bottom && top === right) {
        return top;
    }

    return undefined;
}
